import { useEffect, useState } from 'react';
import { getGeneralSettings } from './api';

// Logo sayfayla birlikte ANINDA görünsün diye sitenin içinde küçük kopyası duruyor (public/logo,
// index.html'de önceden yükleniyor). Eskiden logo ancak JS → ayarlar isteği → görsel sırasıyla,
// sunucu uykudaysa saniyelerce sonra geliyordu; 1600 px / 77 KB'lık asıl dosya 48 px'te gösteriliyordu.
//
// Yönetim panelinden logo değiştirilirse ayarlardaki dosya kimliği değişir: o zaman panelin dosyası
// gösterilir ve tarayıcıya not edilir; sonraki ziyaretler beklemeden onu kullanır.
const GOMULU = {
  light: { kimlik: 'b2654c71-5c93-4943-8e1c-f4cd64ff1e2c', yol: '/logo/agrosjet-acik.webp?v=2' },
  dark: { kimlik: '6e1ae19d-9746-4376-9dc3-5c801bf59d01', yol: '/logo/agrosjet-koyu.webp?v=2' },
};
const ANAHTAR = 'agrosjet_logo_ayar';

const kayitliAyar = () => {
  try {
    return JSON.parse(localStorage.getItem(ANAHTAR)) || null;
  } catch {
    return null;
  }
};

const cozumle = (adres, gomulu) => {
  if (!adres) return null;
  return adres.split('/').pop() === gomulu.kimlik ? gomulu.yol : adres;
};

const logoSec = (ayar, theme) => {
  const birincil = theme === 'dark' ? 'dark' : 'light';
  const ikincil = birincil === 'dark' ? 'light' : 'dark';
  if (!ayar) return GOMULU[birincil].yol;
  return (
    cozumle(ayar[`logo_${birincil}`], GOMULU[birincil]) ||
    cozumle(ayar[`logo_${ikincil}`], GOMULU[ikincil]) ||
    GOMULU[birincil].yol
  );
};

let istek = null; // başlık ve alt bilgi aynı anda sorunca tek istek gitsin

export const useSiteLogo = (theme) => {
  const [ayar, setAyar] = useState(kayitliAyar);

  useEffect(() => {
    let acik = true;
    istek = istek || getGeneralSettings().then((r) => r.data).catch(() => null);
    istek.then((veri) => {
      if (!veri || !acik) return;
      const yeni = { logo_light: veri.logo_light || '', logo_dark: veri.logo_dark || '' };
      try { localStorage.setItem(ANAHTAR, JSON.stringify(yeni)); } catch { /* gizli sekme vb. */ }
      setAyar(yeni);
    });
    return () => { acik = false; };
  }, []);

  return logoSec(ayar, theme);
};
